import {PowerUnit} from '@core/interfaces/system/system-common';

export interface LpInfrastructureRequest {
    infrastructure: InfrastructureDto[];
    unit: PowerUnit;
    includeNetLoad: boolean;
}

export interface InfrastructureDto {
    infrastructureType: InfrastructureType;
    infrastructureId: string;
}

export enum InfrastructureType {
    METER = 'METER',
    DX_TRANSFORMER = 'DX_TRANSFORMER',
    LINE_SECTION = 'LINE_SECTION',
    VAULT = 'VAULT',
    FEEDER = 'FEEDER',
    TRANSFORMER = 'TRANSFORMER',
    STATION_VOLTAGE = 'STATION_VOLTAGE',
    STATION = 'STATION',
    SYSTEM = 'SYSTEM',
    LLA = 'LLA',
    NONE = 'NONE',
}

export const PowerUnitOptions = [PowerUnit.THREE_PHASE_KVA, PowerUnit.THREE_PHASE_KW, PowerUnit.THREE_PHASE_KVAR];
